import { BaseThemeType,BaseSizesType } from 'Shared/frontend/themes/BaseSettings';
import {createContext,useContext} from 'solid-js';

/*
	See https://stackoverflow.com/questions/61132262/typescript-deep-partial for alternatives.
	type-fest looks very popular
*/
export type DeepPartial<T> = T extends object ? {
    [P in keyof T]?: DeepPartial<T[P]>;
} : T;


const ThemeContext = createContext();

export function ThemeProvider(P:{theme:BaseThemeType,settings}) 
{
	return (
		<ThemeContext.Provider value={P}>
			{P.children}
		</ThemeContext.Provider>
	);
}

export function theme():BaseThemeType
{
	return useContext(ThemeContext).theme;
}


//TODO keep? remove? delete? these functions?

export function palette()
{
	return useContext(ThemeContext).theme.palette;
}

export function fonts()
{
	return useContext(ThemeContext).theme.fonts;
}

export function sizes(): BaseSizesType
{
	return useContext(ThemeContext).theme.sizes;
}

export function useSettings():BaseThemeType
{
	return useContext(ThemeContext).settings;
}

